module.exports = __webpack_public_path__ + "img/NewsCenterDetails6_pic1.79878e56.png";